import React, { useEffect } from 'react';
import { useState } from 'react';
import { Fragment } from 'react';
import {
  BsCaretLeftFill,
  BsCaretRightFill,
  BsFillCaretDownFill,
  BsFillCaretUpFill,
} from 'react-icons/bs';
import { connect, useDispatch } from 'react-redux';
import { sortTypeTbl } from '../../containers/banggia/actions';

function DatagridHeader({
  t,
  isPc,
  setIsPc,
  isRoom,
  setIsRoom,
  snapshotRequesting,
}) {
  const dispatch = useDispatch();

  const [sortName, setSortName] = useState(null);
  const [sortType, setSortType] = useState(null);

  useEffect(() => {
    if (snapshotRequesting) {
      setSortName(null);
      setSortType(null);
    }
  }, [snapshotRequesting]);

  const _handleSort = (name) => {
    let _sortType = 'desc';
    if (name !== sortName) {
      setSortName(name);
      setSortType(_sortType);
    } else {
      _sortType = sortType === 'asc' ? 'desc' : 'asc';
      setSortType(_sortType);
    }
    // sortTable && sortTable(sortName, sortType)
    // dispatch to store
    dispatch(sortTypeTbl([name, _sortType]));
  };

  return (
    <Fragment>
      <tr>
        <th
          rowSpan="2"
          className="cursor-n-resize"
          onClick={() => _handleSort('sym')}
        >
          {t('txt-symbol')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'sym' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          rowSpan="2"
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('c')}
        >
          {t('txt-ceil')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'c' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          rowSpan="2"
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('f')}
        >
          {t('txt-floor')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'f' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          rowSpan="2"
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('r')}
        >
          {t('txt-ref')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'r' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th colSpan="6">{t('txt-bid')}</th>
        <th colSpan="3" className="high-light">
          {t('txt-match')}
        </th>
        <th colSpan="6">{t('txt-ask')}</th>
        <th
          rowSpan="2"
          className=" cursor-n-resize"
          onClick={() => _handleSort('lot')}
        >
          {t('txt-total-vol')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'lot' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          rowSpan="2"
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('highPrice')}
        >
          {t('txt-high')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'highPrice' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          rowSpan="2"
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('lowPrice')}
        >
          {t('txt-low')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'lowPrice' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          rowSpan="2"
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('avePrice')}
        >
          {t('txt-ave')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'avePrice' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th colSpan="2">{t('txt-foreign')}</th>
        <th colSpan="2">Dư</th>
      </tr>
      <tr>
        <th>{t('txt-price')} 3</th>
        <th>{t('txt-vol')} 3</th>
        <th>{t('txt-price')} 2</th>
        <th>{t('txt-vol')} 2</th>
        <th>{t('txt-price')} 1</th>
        <th>{t('txt-vol')} 1</th>
        <th
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('lastPrice')}
        >
          {t('txt-price')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'lastPrice' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th
          className="high-light cursor-n-resize"
          onClick={() => _handleSort('lastVolume')}
        >
          {t('txt-vol')}
          <span className="position-absolute icon-sort-header">
            {sortName === 'lastVolume' &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th className="high-light cursor-n-resize position-relative">
          <span className="slidable">
            <div
              className="cell-1-1 cursor-n-resize"
              onClick={() => _handleSort(isPc ? 'changePc' : 'change')}
            >
              {isPc ? '%' : '+/-'}
            </div>
          </span>
          <span className="position-absolute icon-sort-header">
            {((sortName === 'changePc' && isPc) ||
              (sortName === 'change' && !isPc)) &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
          <BsCaretLeftFill
            className="tbl-toggle-left"
            onClick={() => setIsPc(!isPc)}
          />
          <BsCaretRightFill
            className="tbl-toggle-right"
            onClick={() => setIsPc(!isPc)}
          />
        </th>
        <th>{t('txt-price')} 1</th>
        <th>{t('txt-vol')} 1</th>
        <th>{t('txt-price')} 2</th>
        <th>{t('txt-vol')} 2</th>
        <th>{t('txt-price')} 3</th>
        <th>{t('txt-vol')} 3</th>
        <th colSpan="2" className="position-relative">
          <span className="slidable">
            {isRoom ? (
              <Fragment>
                <div
                  className="cell-1-2 cursor-n-resize"
                  onClick={() => _handleSort('fBVol')}
                >
                  {t('txt-buy')}
                  <span className="position-absolute icon-sort-header">
                    {sortName === 'fBVol' &&
                      isRoom &&
                      (sortType === 'asc' ? (
                        <BsFillCaretUpFill className="fz-10" />
                      ) : (
                        <BsFillCaretDownFill className="fz-10" />
                      ))}
                  </span>
                </div>
                <div
                  className="cell-1-2 cursor-n-resize"
                  onClick={() => _handleSort('fSVolume')}
                >
                  {t('txt-sell')}
                  <span className="position-absolute icon-sort-header">
                    {sortName === 'fSVolume' &&
                      isRoom &&
                      (sortType === 'asc' ? (
                        <BsFillCaretUpFill className="fz-10" />
                      ) : (
                        <BsFillCaretDownFill className="fz-10" />
                      ))}
                  </span>
                </div>
              </Fragment>
            ) : (
              <div
                className="cell-1-1 cursor-n-resize"
                onClick={() => _handleSort('fRoom')}
              >
                Room
              </div>
            )}
          </span>
          <BsCaretLeftFill
            className="tbl-toggle-left"
            onClick={() => setIsRoom(!isRoom)}
          />
          <BsCaretRightFill
            className="tbl-toggle-right"
            onClick={() => setIsRoom(!isRoom)}
          />
          <span className="position-absolute icon-sort-header">
            {sortName === 'fRoom' &&
              !isRoom &&
              (sortType === 'asc' ? (
                <BsFillCaretUpFill className="fz-10" />
              ) : (
                <BsFillCaretDownFill className="fz-10" />
              ))}
          </span>
        </th>
        <th>{t('txt-buy')}</th>
        <th>{t('txt-sell')}</th>
        {/* <th>{t('txt-buy')}</th>
        <th>{t('txt-sell')}</th> */}
      </tr>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  // console.log(state.priceBoard)
  return {
    snapshotRequesting: state.priceBoard.snapshotRequesting,
  };
};

export default connect(mapStateToProps)(DatagridHeader);
